import gsap, { Linear } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

export class Statement {
    constructor(el) {
        gsap.registerPlugin(ScrollTrigger);
        this.el = el;

        this.el && this.init();
    }

    init() {
        const text = this.el.querySelector(".statement__text");
        const split = new SplitType(text, { types: ["words", "chars"] });
        split.words.forEach(word => {
            word.setAttribute("aria-hidden", true);
        });

        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: text,
                start: "top+=150 bottom",
                end: "bottom top-=150",
                scrub: 1,
                onUpdate: self => {
                    this.el.style.setProperty("--progress", `${self.progress}`);
                },
            },
            defaults: {
                ease: Linear.easeNone,
            },
        });

        this.tl.from(split.chars, {
            opacity: 0.1,
            stagger: 0.01,
        });

        this.tl.set({}, {}, ">+=.8");
    }

    destroy() {
        this.tl.destroy();
    }
}

const statements = () => {
    const statements = document.querySelectorAll(".statement");

    statements &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
        statements.forEach(statement => {
            new Statement(statement);
        });
};

export default statements;
